/**
 * AycanDesignPicker — Web Component
 * Grid swatch seçici + çoklu seçim + qty input + Cart API
 * selection_mode: single + data-external-atc → Dawn buy_buttons entegrasyonu
 * Dawn PubSub: publish(PUB_SUB_EVENTS.cartUpdate, ...) ile drawer tetiklenir.
 */
class AycanDesignPicker extends HTMLElement {
  connectedCallback() {
    const mapEl = this.querySelector('.aycan-variant-map');
    const variantsEl = this.querySelector('.aycan-variants-data');
    try {
      this.variantMap = mapEl ? JSON.parse(mapEl.textContent) : {};
    } catch {
      this.variantMap = {};
    }
    try {
      this.variantsData = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    } catch {
      this.variantsData = [];
    }
    this.selected = new Map(); // code → { variantId: Number, qty: Number }

    this.selectionMode = this.dataset.selectionMode || 'multi';
    this.externalAtc = this.dataset.externalAtc === 'true';
    this.showQty = Boolean(this.querySelector('.aycan-swatch__qty'));

    // Modal yolunda ATC iki yerde: modal içinde + PDP'de (karar #4). İkisi birlikte yönetilir.
    this.atcBtns   = [...this.querySelectorAll('.aycan-design-picker__atc')];
    this.atcBtn    = this.atcBtns[0] || null;
    this.errorEl   = this.querySelector('.aycan-design-picker__error');
    this.summaryEl = this.querySelector('.aycan-design-picker__summary');
    this.countEl   = this.querySelector('.aycan-design-picker__count');
    this.atcLabel  = this.atcBtn?.querySelector('.aycan-atc__label');
    this._defaultAtcLabel = this.atcLabel?.textContent?.trim() || '';

    this._bindEvents();
    this._initModal();
    this._initSwatchImageFallback();

    if (this.selectionMode === 'single') {
      this._initSingleSelection();
    } else {
      this._updateSummary();
    }
  }

  /**
   * Modal picker — grid eşik üstündeyse dialog'un içinde render edilir.
   * Grid/qty/ATC hâlâ this kapsamında olduğu için diğer selector'lar değişmez.
   * Native showModal() focus trap + Esc'i kendisi getirir.
   */
  _initModal() {
    this.modal = this.querySelector('.aycan-picker-modal');
    this.trigger = this.querySelector('.aycan-picker-trigger');
    if (!this.modal || !this.trigger) return;

    // Mobilde modal yok (karar #6): dialog display:contents ile inline akar
    this._desktopMq = window.matchMedia('(min-width: 750px)');

    this.trigger.addEventListener('click', () => {
      if (!this._desktopMq.matches) return;
      this.modal.showModal();
      // showModal SONRASI: dialog kapalıyken gövdenin ölçüsü 0'dır
      this._fitModalGrid();
      this.trigger.setAttribute('aria-expanded', 'true');
      window.ewaTrack?.('pdp_picker_open', { picker_type: 'design' });
    });

    window.addEventListener('resize', () => {
      if (this.modal.open) this._fitModalGrid();
    });

    // Done ve × aynı işi yapar: seçimi koruyarak kapat. Done'ın işi görünürlük —
    // sepete eklemenin tek çıkış olmadığını footer'da açıkça gösterir.
    this.modal.querySelectorAll('.aycan-picker-modal__close, .aycan-picker-modal__done').forEach((btn) => {
      btn.addEventListener('click', () => this.modal.close());
    });

    // Backdrop tıklaması — panel dialog'u tamamen doldurduğu için
    // e.target === dialog yalnızca backdrop'ta olur
    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) this.modal.close();
    });

    this.modal.addEventListener('close', () => {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.focus({ preventScroll: true });
    });

    // Seçim yokken gösterilecek varsayılan önizleme — geri dönebilmek için saklanır
    this._thumbsWrap = this.trigger.querySelector('.aycan-picker-trigger__thumbs');
    this._moreEl = this.trigger.querySelector('.aycan-picker-trigger__more');
    this._defaultThumbs = this._thumbsWrap
      ? [...this._thumbsWrap.children].map((node) => node.cloneNode(true))
      : [];
    this._defaultMoreText = this._moreEl?.textContent.trim() || '';
    this._previewMax = this._defaultThumbs.length || 8;
  }

  /**
   * Fill grid — sütun sayısı ürüne göre çözülür, sabit değil.
   *
   * Swatch'ler aspect-ratio:1 olduğu için satır yüksekliği = sütun genişliği:
   * sütun sayısı hem yatay hem DİKEY sığmayı belirler. Sabit sütun sayısı bu
   * yüzden ürün başına ya scroll (57 varyant) ya da büyük boşluk (35 varyant)
   * üretiyordu. Dikey sığan en AZ sütunu seçeriz — en az sütun = en büyük swatch.
   */
  _fitModalGrid() {
    const body = this.modal?.querySelector('.aycan-picker-modal__body');
    const grid = body?.querySelector('.aycan-design-picker__grid');
    if (!body || !grid) return;

    const n = grid.querySelectorAll('.aycan-swatch-item').length;

    // clientWidth/Height padding'i İÇERİR; gövdenin padding'i ring ve qty payı
    // için var, grid'e ayrılan alan değil — düşülmezse çözücü fazla yer sanır.
    const bcs = getComputedStyle(body);
    const w = body.clientWidth - parseFloat(bcs.paddingLeft) - parseFloat(bcs.paddingRight);
    const h = body.clientHeight - parseFloat(bcs.paddingTop) - parseFloat(bcs.paddingBottom);
    if (!n || w <= 0 || h <= 0) return;

    const cs = getComputedStyle(grid);
    const gap = parseFloat(cs.columnGap) || 12;
    const rowGap = parseFloat(cs.rowGap) || gap + 8;

    let cols = 0;
    let bestCell = 0;
    for (let c = 1; c <= n; c++) {
      const rows = Math.ceil(n / c);
      const cellW = (w - (c - 1) * gap) / c;
      const totalH = rows * cellW + (rows - 1) * rowGap;
      if (totalH <= h && cellW > bestCell) {
        bestCell = cellW;
        cols = c;
      }
    }

    // Hiçbir sütun sayısı dikey sığmıyorsa CSS varsayılanına bırak — gövde kayar.
    if (cols) grid.style.setProperty('--modal-cols', cols);
  }

  /**
   * Karar #3: seçim özeti = küçük thumbnail'lar.
   * Seçim varsa tetikleyici seçilenleri gösterir ("+n designs" gizlenir — sayı/tutar
   * zaten ATC'de); seçim boşalınca varsayılan önizlemeye döner.
   */
  _updateTriggerThumbs() {
    if (!this._thumbsWrap) return;

    const selectedImgs = [
      ...this.querySelectorAll('.aycan-swatch-item--selected .aycan-swatch__btn--image img'),
    ];

    if (!selectedImgs.length) {
      this._thumbsWrap.replaceChildren(...this._defaultThumbs.map((n) => n.cloneNode(true)));
      if (this._moreEl) this._moreEl.textContent = this._defaultMoreText;
      return;
    }

    const shown = selectedImgs.slice(0, this._previewMax).map((img) => {
      const span = document.createElement('span');
      span.className = 'aycan-picker-trigger__thumb';
      const clone = img.cloneNode();
      clone.removeAttribute('loading');
      clone.alt = '';
      span.appendChild(clone);
      return span;
    });

    this._thumbsWrap.replaceChildren(...shown);
    // "+n designs" seçimle anlamını yitirir; yerine sağ tarafta kalıcı bir
    // düzenleme tutamağı kalır — yoksa pill ölü bir input gibi görünüyor
    if (this._moreEl) this._moreEl.textContent = this.dataset.changeLabel || this._defaultMoreText;
  }

  _getAtcLabels() {
    const dock = document.getElementById(`pdp-mobile-dock-${this.dataset.sectionId}`);
    return {
      selectLabel: dock?.dataset.selectLabel || 'Select designs',
      defaultLabel: this._defaultAtcLabel || dock?.dataset.atcLabel || 'Add to cart',
    };
  }

  /**
   * "Add 6 · ¥17,400" — karar #4: belirsiz "Done" yerine betimleyici fiil+sayı+tutar.
   * Şablon data-add-label'dan gelir (çeviri); yoksa atc_label ayarına düşer.
   */
  _composeAddLabel(fallback) {
    const tpl = this.dataset.addLabel;
    if (!tpl) return fallback;
    const price = this._formatMoney(this._computeSelectionTotalCents());
    return tpl.replace('__COUNT__', String(this.selected.size)).replace('__PRICE__', price);
  }

  _applyBuyboxAtc(canAdd) {
    if (!this.atcBtns.length || this.externalAtc) return;
    const { selectLabel, defaultLabel } = this._getAtcLabels();
    const ready = Boolean(canAdd);
    const text = ready ? this._composeAddLabel(defaultLabel) : selectLabel;

    this.atcBtns.forEach((btn) => {
      btn.disabled = false;
      btn.classList.toggle('is-select-mode', !ready);
      const label = btn.querySelector('.aycan-atc__label');
      if (label) label.textContent = text;
    });
  }

  /** Seçim yokken ATC: masaüstünde modalı aç, mobilde grid'e kaydır. */
  _revealPicker() {
    if (this.modal && this._desktopMq?.matches) {
      this.modal.showModal();
      this.trigger?.setAttribute('aria-expanded', 'true');
      return;
    }
    this._scrollToPicker();
  }

  _scrollToPicker() {
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const first = this.querySelector('.aycan-swatch__btn:not([disabled])');
    first?.focus({ preventScroll: true });
  }

  _bindEvents() {
    this.addEventListener('click', (event) => {
      if (event.target.closest('.aycan-swatch__qty, .aycan-qty__minus, .aycan-qty__plus, .aycan-qty__input')) {
        return;
      }
      const btn = event.target.closest('.aycan-swatch__btn');
      if (!btn || btn.disabled || !this.contains(btn)) return;
      const item = btn.closest('.aycan-swatch-item');
      if (!item) return;
      event.preventDefault();
      this._handleSwatchClick(item);
    });

    this.querySelectorAll('.aycan-qty__minus').forEach(btn => {
      btn.addEventListener('click', (event) => {
        event.stopPropagation();
        this._adjustQty(btn.closest('.aycan-swatch-item'), -1);
      });
    });

    this.querySelectorAll('.aycan-qty__plus').forEach(btn => {
      btn.addEventListener('click', (event) => {
        event.stopPropagation();
        this._adjustQty(btn.closest('.aycan-swatch-item'), 1)
      });
    });

    this.querySelectorAll('.aycan-qty__input').forEach(input => {
      input.addEventListener('click', (event) => event.stopPropagation());
      input.addEventListener('change', () => {
        const item = input.closest('.aycan-swatch-item');
        const code = item.dataset.code;
        const val  = Math.max(1, Math.min(99, parseInt(input.value) || 1));
        input.value = val;
        if (this.selected.has(code)) {
          this.selected.get(code).qty = val;
          this._updateSummary();
        }
      });
    });

    this.atcBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (this.selected.size === 0) {
          this._revealPicker();
          window.ewaTrack?.('pdp_atc_incomplete', { picker_type: 'design' });
          return;
        }
        this._addToCart();
      });
    });
  }

  _handleSwatchClick(item) {
    if (this.selectionMode === 'single') {
      if (item.classList.contains('aycan-swatch-item--selected')) return;
      this.querySelectorAll('.aycan-swatch-item--selected').forEach(el => this._deselectItem(el));
      this._selectItem(item);
      return;
    }

    const isSelected = !item.classList.contains('aycan-swatch-item--selected');
    if (isSelected) {
      this._selectItem(item);
    } else {
      this._deselectItem(item);
    }
  }

  _selectItem(item) {
    const code = item.dataset.code;
    const qtyEl = item.querySelector('.aycan-swatch__qty');
    const qtyInputs = qtyEl?.querySelectorAll('.aycan-qty__input, .aycan-qty__minus, .aycan-qty__plus') || [];

    item.classList.add('aycan-swatch-item--selected');
    item.querySelector('.aycan-swatch__btn').setAttribute('aria-pressed', 'true');

    if (qtyEl) {
      qtyEl.hidden = false;
      qtyEl.setAttribute('aria-hidden', 'false');
      qtyInputs.forEach(el => (el.tabIndex = 0));
    }

    const qty = qtyEl ? (parseInt(qtyEl.querySelector('.aycan-qty__input').value) || 1) : 1;
    const variantId = parseInt(item.dataset.variantId, 10);
    this.selected.set(code, { variantId, qty });

    if (this.externalAtc) {
      this._syncExternalVariant(variantId);
      this._emitDockUpdate();
    } else {
      this._updateSummary();
    }
  }

  _deselectItem(item) {
    const code = item.dataset.code;
    const qtyEl = item.querySelector('.aycan-swatch__qty');
    const qtyInputs = qtyEl?.querySelectorAll('.aycan-qty__input, .aycan-qty__minus, .aycan-qty__plus') || [];

    item.classList.remove('aycan-swatch-item--selected');
    item.querySelector('.aycan-swatch__btn').setAttribute('aria-pressed', 'false');

    if (qtyEl) {
      qtyEl.hidden = true;
      qtyEl.setAttribute('aria-hidden', 'true');
      qtyInputs.forEach(el => (el.tabIndex = -1));
      const input = qtyEl.querySelector('.aycan-qty__input');
      if (input) input.value = 1;
    }

    this.selected.delete(code);
    this._updateSummary();
  }

  _initSingleSelection() {
    const params = new URLSearchParams(window.location.search);
    const variantParam = params.get('variant');
    let item = null;

    if (variantParam) {
      item = this.querySelector(`.aycan-swatch-item[data-variant-id="${variantParam}"]`);
    }
    if (!item) {
      item = this.querySelector('.aycan-swatch-item[data-available="true"]')
        || this.querySelector('.aycan-swatch-item');
    }
    if (item) this._selectItem(item);
  }

  _getVariantById(variantId) {
    return this.variantsData.find((v) => String(v.id) === String(variantId)) || null;
  }

  _updateFormVariantId(variantId) {
    const formId = this.dataset.productFormId;
    if (!formId) return;

    document.querySelectorAll(`#${formId}, #product-form-installment-${this.dataset.sectionId}`).forEach((form) => {
      const input = form.querySelector('input[name="id"]');
      if (!input) return;
      input.value = variantId ?? '';
      input.disabled = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  _syncExternalVariant(variantId) {
    const sectionId = this.dataset.sectionId;
    const productInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
    const productUrl = productInfo?.dataset.url || window.location.pathname;
    const variant = this._getVariantById(variantId);

    this._updateFormVariantId(variantId);

    if (!productInfo) {
      if (variant && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.variantChange, {
          data: { sectionId, html: document, variant },
        });
      }
      return;
    }

    fetch(`${productUrl}?variant=${variantId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const fetchedVariant = this._getVariantById(variantId) || variant;

        productInfo.updateVariantInputs(variantId);

        const updateSourceFromDestination = (id, shouldHide = () => false) => {
          const source = html.getElementById(`${id}-${sectionId}`);
          const destination = productInfo.querySelector(`#${id}-${sectionId}`);
          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            destination.classList.toggle('hidden', shouldHide(source));
          }
        };

        updateSourceFromDestination('price');
        updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
        updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
        updateSourceFromDestination('Volume');
        updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

        if (fetchedVariant?.featured_media?.id) {
          productInfo.updateMedia(html, fetchedVariant.featured_media.id);
        }

        const submitSrc = html.getElementById(`ProductSubmitButton-${sectionId}`);
        const productForm = document.getElementById(`product-form-${sectionId}`)?.closest('product-form');
        if (submitSrc && productForm) {
          productForm.toggleSubmitButton(
            submitSrc.hasAttribute('disabled'),
            window.variantStrings?.soldOut
          );
        }

        if (productInfo.dataset.updateUrl !== 'false') {
          window.history.replaceState({}, '', `${productUrl}?variant=${variantId}`);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: fetchedVariant,
            },
          });
        }
      })
      .catch((err) => console.error('aycan-design-picker variant sync failed', err));
  }

  _adjustQty(item, delta) {
    const input = item.querySelector('.aycan-qty__input');
    if (!input) return;
    const newVal = Math.max(1, Math.min(99, (parseInt(input.value) || 1) + delta));
    input.value = newVal;
    const code = item.dataset.code;
    if (this.selected.has(code)) {
      this.selected.get(code).qty = newVal;
      this._updateSummary();
    }
  }

  _formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  _computeSelectionTotalCents() {
    let total = 0;
    for (const [, { variantId, qty }] of this.selected) {
      const variant = this._getVariantById(variantId);
      if (variant?.price) total += variant.price * qty;
    }
    return total;
  }

  _updateSummary() {
    const count    = this.selected.size;
    const totalQty = [...this.selected.values()].reduce((s, { qty }) => s + qty, 0);
    const hasItems = count > 0;

    if (this.countEl) {
      this.countEl.textContent = `${count} selected`;
      this.countEl.classList.toggle('is-empty', !hasItems);
      this.countEl.setAttribute('aria-hidden', hasItems ? 'false' : 'true');
    }

    if (this.summaryEl) {
      this.summaryEl.hidden = !hasItems;
      if (hasItems) {
        this.summaryEl.textContent =
          totalQty === count
            ? `${count} design × 1 each`
            : `${count} designs, ${totalQty} total`;
      }
    }

    if (this.atcBtns.length && !this.externalAtc) this._applyBuyboxAtc(hasItems);

    this._updateTriggerThumbs();
    this._emitDockUpdate();
  }

  _getDockThumb() {
    const items = [...this.querySelectorAll('.aycan-swatch-item--selected')];
    const last = items[items.length - 1];
    const img = last?.querySelector('.aycan-swatch__btn--image img');
    if (img?.currentSrc || img?.src) return img.currentSrc || img.src;
    const dock = document.getElementById(`pdp-mobile-dock-${this.dataset.sectionId}`);
    const thumb = dock?.querySelector('.pdp-mobile-dock__thumb');
    return thumb?.tagName === 'IMG' ? thumb.src : '';
  }

  _emitDockUpdate() {
    if (typeof window.pdpDockUpdate !== 'function') return;

    const count = this.selected.size;
    const hasItems = count > 0;
    const totalCents = hasItems ? this._computeSelectionTotalCents() : 0;
    const dock = document.getElementById(`pdp-mobile-dock-${this.dataset.sectionId}`);
    const selectLabel = dock?.dataset.selectLabel || 'Select designs';
    const defaultLabel = this.atcLabel?.textContent?.trim() || dock?.dataset.atcLabel || 'Add to cart';

    window.pdpDockUpdate(this.dataset.sectionId, {
      thumbSrc: this._getDockThumb(),
      selectionLine: hasItems ? `${count} selected · ${this._formatMoney(totalCents)}` : '',
      ctaLabel: hasItems ? defaultLabel : selectLabel,
      ctaDisabled: false,
      ctaMode: hasItems ? 'add' : 'scroll',
    });
  }

  async _addToCart() {
    if (this.selected.size === 0) return;

    const items = [...this.selected.entries()].map(([, { variantId, qty }]) => ({
      id: variantId,
      quantity: qty,
    }));

    this._setLoading(true);

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      let sections = ['cart-icon-bubble'];
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        sections = cartDrawer.getSectionsToRender().map((s) => s.id);
      }

      const resp = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items, sections, sections_url: window.location.pathname }),
      });

      const data = await resp.json();

      if (!resp.ok) {
        throw new Error(data.description || 'Could not add to cart.');
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source:       'aycan-design-picker',
        productVariantId: items[0]?.id,
        cartData:     data,
      });

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      }

      this._resetSelection();
      window.ewaTrack?.('pdp_add_to_cart', { picker_type: 'design', atc_items: items.length });
      // Ekleme başarılı → modal kapanır, drawer aynı yanıttan render edilir
      if (this.modal?.open) this.modal.close();
    } catch (err) {
      window.ewaTrack?.('pdp_atc_error', { picker_type: 'design', atc_error: err.message });
      this.errorEl.textContent = err.message;
      this.errorEl.hidden = false;
    } finally {
      this._setLoading(false);
    }
  }

  _setLoading(isLoading) {
    this.atcBtns.forEach((btn) => {
      btn.disabled = isLoading;
      btn.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);
      btn.querySelector('.aycan-atc__label')?.classList.toggle('hidden', isLoading);
    });
    window.pdpDockUpdate?.(this.dataset.sectionId, { loading: isLoading });
    if (!isLoading) this._updateSummary();
  }

  _resetSelection() {
    this.selected.clear();
    this.querySelectorAll('.aycan-swatch-item').forEach(item => {
      this._deselectItem(item);
    });
    if (this.errorEl) this.errorEl.hidden = true;
  }

  _initSwatchImageFallback() {
    this.querySelectorAll('.aycan-swatch__btn--image img').forEach(img => {
      img.addEventListener('error', () => {
        const btn = img.closest('.aycan-swatch__btn');
        const figure = img.closest('.aycan-swatch__figure');
        btn.classList.remove('aycan-swatch__btn--image');
        figure?.remove();
        img.remove();
        btn.textContent = btn.dataset.fallback || '';
      }, { once: true });
    });
  }
}

customElements.define('aycan-design-picker', AycanDesignPicker);
